import { ContentCopyRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useCallback, useMemo, useState } from "react";

interface Props {
  text: string;
  contentType?: string;
}

const ContentCopy = ({ text, contentType }: Props) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [text]);

  const title = useMemo(
    () => (copied ? `Copied` : `Copy ${contentType ? contentType : ""}`),
    [contentType, copied]
  );

  return (
    <Tooltip title={title} placement="left">
      <IconButton onClick={handleCopy} size="small">
        <ContentCopyRounded />
      </IconButton>
    </Tooltip>
  );
};

export default ContentCopy;
